export const LoginPage = (destinationLang) => {
  return [
    {
      FormKey: 'login-label-welcome',
      Key: 'خوش آمدید',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-button-enter',
      Key: 'ورود',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-link-forgot-password',
      Key: 'فراموشی رمز',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-label-or-seperator',
      Key: 'یا',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-input-user-name',
      Key: 'نام کاربری',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-password-key',
      Key: 'رمز عبور',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-link-sign-up',
      Key: 'حساب کاربری ندارید؟ ثبت نام کنید',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-input-telephone-number',
      Key: 'ورود با شماره تلفن همراه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-button-password-recovery',
      Key: 'باز نشانی رمز عبور',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-input-auth-code',
      Key: 'ورود کد احراز هویت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-alert-sms-sent',
      Key: 'پیامک با موفقیت ارسال شد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-btn-login-as-guest',
      Key: 'ورود مهمان',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-username-hint',
      Key: 'در صورتیکه نام کاربری را تغییر نداده اید ، نام کاربری همان کد ملی میباشد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-btn-sent-sms-login',
      Key: 'ارسال پیام',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'login-alert-send-sms-mobile-number',
      Key: 'آیا از صحت شماره وارد شده اطمینان دارید؟',
      DistinitationLanguage: destinationLang,
    },
  ];
};
